import 'Utils/validation';
import React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { QueryClientProvider } from 'react-query';
import { Provider as ApiProvider } from 'Utils/Api/index';
import { queryClient } from 'Utils/queryClient';
import Router from './Components/CustomRouter';
import theme from './theme';
import history from './history';
import App from './App';

const container = document.getElementById('root');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ApiProvider>
            <Router history={history}>
              <App />
            </Router>
          </ApiProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
